<app-solutions-header-banner></app-solutions-header-banner>

<div class="container w-full mx-auto my-10 px-10 flex flex-col gap-5 md:gap-3 justify-center items-center">
  <h2 class="font-bold text-3xl website-heading">Vehicle Users(B2C)</h2>
  <span class="font-light text-2xl website-light-heading">Make Your Vehicle Smarter</span>

  <span class="text-l text-justify w-full mt-5 color-[#0A0A0A]">With our solution, maximize your connected vehicle's
    capabilities through an integrated platform and real-time data. We provide intuitive software, a smart plug device,
    and a user-friendly mobile app. The app delivers real-time data from the smart plug, offering comprehensive insights
    into your vehicle's health and empowering you with actionable information at your fingertips.</span>

  <span class="text-l text-center w-full mt-5 color-[#0A0A0A]">Users can easily set up a connected experience within 30
    minutes. If you need assistance, our backend experts are available by phone or email to help you get started
    promptly.</span>

  <!-- Horizontal Banner (Visible only on medium and above screens) -->
  <div class="relative w-full mt-10 hidden md:block">
    <img [src]="Images.SOLUTION_B2C_HORIZONTAL_BANNER" alt="Varroc Connect B2C Vehicle User Solutions" class="w-full">
  </div>

  <!-- Vertical Banner (Visible only on small screens) -->
  <div class="relative w-[50%] mt-10 block md:hidden">
    <img [src]="Images.SOLUTION_B2C_VERTICAL_BANNER" alt="Varroc Connect B2C Vehicle User Solutions" class="w-full">
  </div>

  <span class="text-l text-center w-full mt-5 color-[#0A0A0A]">Some of the key features from our extensive array of over
    50 features</span>


</div>

<div class="container mx-auto px-5 w-11/12 flex flex-col justify-center items-center gap-3">
  <!-- Row 1 -->
  <div class="flex gap-6 md:flex-row flex-col mt-5 w-full">
    <div class="flex flex-1 rounded-md store-container-border p-6 shadow-md items-center gap-3">
      <img [src]="Images.STAR_ICON" alt="" class="size-6">
      <span>Varroc Connect Score</span>
    </div>
    <div class="flex flex-1 rounded-md store-container-border p-6 shadow-md items-center gap-3">
      <img [src]="Images.STAR_ICON" alt="" class="size-6">
      <span class="whitespace-nowrap">Trips and Trip Replay Option</span>
    </div>
  </div>

  <!-- Row 2 -->
  <div class="flex gap-6 md:flex-row flex-col mt-5 w-full">
    <div class="flex flex-1 rounded-md store-container-border p-6 shadow-md items-center gap-3">
      <img [src]="Images.STAR_ICON" alt="" class="size-6">
      <span>Real-Time Vehicle Tracking</span>
    </div>
    <div class="flex flex-1 rounded-md store-container-border p-6 shadow-md items-center gap-3">
      <img [src]="Images.STAR_ICON" alt="" class="size-6">
      <span class="whitespace-nowrap">Driving Summary Report</span>
    </div>
  </div>

  <!-- Row 3 -->
  <div class="flex gap-6 md:flex-row flex-col mt-5 w-full">
    <div class="flex flex-1 rounded-md store-container-border p-6 shadow-md items-center gap-3">
      <img [src]="Images.STAR_ICON" alt="" class="size-6">
      <span>Driving Behavior Analysis: Assessment of driving habits </span>
    </div>
    <div class="flex flex-1 rounded-md store-container-border p-6 shadow-md items-center gap-3">
      <img [src]="Images.STAR_ICON" alt="" class="size-6">
      <span>Geo-Fence: Setting up a virtual boundary</span>
    </div>
  </div>
</div>